import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import type { Position } from '@recruitee/http-types';
import type {
  InterviewTemplate,
  InterviewTemplateDetail,
  InterviewTemplateKind,
} from '@recruitee/interview-templates-types';

@Injectable({ providedIn: 'root' })
export class InterviewTemplatesHttpService {
  constructor(protected httpApi: HttpApiService) {}

  public fetchCollection(params: {
    kind: InterviewTemplateKind;
  }): Observable<{ interviewTemplates: InterviewTemplate[] }> {
    return this.httpApi.get(`/interview/templates`, params);
  }

  public fetchOne({
    id,
  }: {
    id: number;
  }): Observable<{ interviewTemplate: InterviewTemplateDetail }> {
    return this.httpApi.get(`/interview/templates/${id}`);
  }

  public create(data: any): Observable<{ interviewTemplate: InterviewTemplateDetail }> {
    return this.httpApi.post(`/interview/templates`, null, { interview_template: data });
  }

  public delete(id: number): Observable<{ interviewTemplate: InterviewTemplateDetail }> {
    return this.httpApi.delete(`/interview/templates/${id}`);
  }

  public update(id: number, data: any): Observable<{ interviewTemplate: InterviewTemplateDetail }> {
    const body = { interview_template: data };
    return this.httpApi.patch(`/interview/templates/${id}`, null, body);
  }

  // No details here
  public updatePositions(
    positions: Position[],
  ): Observable<{ interviewTemplates: InterviewTemplate[] }> {
    return this.httpApi.patch(`/interview/templates/update_positions`, null, {
      interview_templates: positions,
    });
  }

  public duplicate(
    sourceTemplateId: number,
  ): Observable<{ interviewTemplate: InterviewTemplateDetail }> {
    return this.httpApi.post(`/interview/templates/${sourceTemplateId}`);
  }

  public fetchCategories(kind: string): Observable<string[]> {
    return this.httpApi
      .get('/interview/templates/categories', { kind })
      .pipe(map(data => data.categories));
  }
}
